export default __webpack_public_path__ + "static/media/gallery_06.bf5c1e98.jpg";